__turbopack_context__.v({
  "className": "vr5cnG_className",
  "variable": "vr5cnG_variable",
});
